export default "__VITE_ASSET__CMfqaYuI__"